// extracted by mini-css-extract-plugin
module.exports = {"imageContainer":"styles_imageContainer__2XMuO","image":"styles_image__1mtIk","noAnimation":"styles_noAnimation__2yQxC"};